export default __webpack_public_path__ + "images/Transcerebellar_View_dark.90db30efae175b4588447e5d5cb39395.png";